import React, { useEffect, useState } from "react";
import "./myAssessment.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  getReport,
  resetLoading,
  getDownloadReport,
} from "../../Redux/ActionCreators/reportAction";
import { resetTestLoader } from "../../Redux/ActionCreators/myAssessmentAction";
import { convertDate, formatAMPM } from "../../utils/miscelleneous";
import { Table } from "react-bootstrap";
import exportFromJSON from "export-from-json";
import { Dialog } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

export default function AssessmentReport() {
  const [sortVal, setSortVal] = useState(2);
  const [pageCount, setPageCount] = useState(1);
  const [search, setSearch] = useState("");
  const [loadData, setLoadData] = useState(false);
  const [testId, setTestId] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const rows = 10;
  const { testReport, totalCount, isReportLoading } = useSelector(
    (state) => state.report,
  );
  const timerRef2 = React.useRef(null);

  const ruleSetJson = location?.state?.ruleSetJson || null;

  useEffect(() => {
    const firstRender = async () => {
      setTestId(location.state.id);
      await dispatch(resetLoading());
      const initialSearch = location?.state?.prefilledEmail || "";
      if (initialSearch) setSearch(initialSearch);
      const res = await dispatch(
        getReport(location.state.id, initialSearch, 1, rows, sortVal),
      );
      if (res?.type === "GET_REPORT") {
      }
    };
    firstRender();
  }, [location.state.id, dispatch, rows, sortVal]);

  const selectSort = async (val) => {
    setSortVal(val);
    setPageCount(1);
    // await dispatch(getReport(testId, val, 1, rows, val));
  };

  // const fetchNextReportData = () => {
  //     setPageCount(pageCount + 1);
  //     dispatch(getNextReport(testId, '', pageCount + 1, rows, sortVal));
  // }

  const searchName = (val) => {
    clearTimeout(timerRef2.current);
    setSearch(val);
    setPageCount(1);
    timerRef2.current = setTimeout(() => delaySearch(val), 800);
  };

  const delaySearch = async (val) => {
    await dispatch(resetTestLoader());
    await dispatch(getReport(testId, val, pageCount, rows, sortVal));
  };

  const openOneReport = (id) => {
    navigate("/test-report", {
      state: { id: id, type: "new", myTest: true, path: "assessment" },
    });
  };

  const downloadData = async () => {
    await setLoadData(true);
    const res = await dispatch(getDownloadReport(testId));

    if (res?.type === "GET_DOWNLOAD_REPORT") {
      const reports = res.payload?.reports || [];

      // 🧩 Step 1: Parse ruleSetJson mapping (TestId -> Test Name)
      let testIdNameMap = {};
      if (ruleSetJson && typeof ruleSetJson === "string") {
        try {
          const parsedRuleSet = JSON.parse(ruleSetJson);
          parsedRuleSet?.tests?.forEach((t) => {
            testIdNameMap[t.testid] = t.name?.trim();
          });
        } catch (err) {
          console.error("Invalid ruleSetJson:", err);
        }
      }

      // 🧩 Step 2: Gather all possible CSV columns dynamically
      const allColumns = new Set([
        "Name",
        "Email",
        "Test",
        "Test Attempt Date",
      ]);

      reports.forEach((el) => {
        if (el.dynamicEvaluationResult) {
          try {
            const parsed = JSON.parse(el.dynamicEvaluationResult);

            // AlignmentResults → DisplayName
            parsed?.AlignmentResults?.forEach((r) => {
              if (r.DisplayName) allColumns.add(r.DisplayName);
            });

            // NormalizedTestScores → map TestId -> name
            parsed?.NormalizedTestScores?.forEach((r) => {
              const testName = testIdNameMap[r.TestId];
              if (testName) allColumns.add(testName);
            });
          } catch (err) {
            console.error("Invalid dynamicEvaluationResult JSON:", err);
          }
        } else {
          // dynamicEvaluationResult is null → use testDetails
          el.testDetails?.forEach((td) => {
            if (td.testName) allColumns.add(td.testName.trim());
          });
        }
      });

      // Convert to array for iteration (consistent order)
      const columns = Array.from(allColumns);

      // 🧩 Step 3: Prepare CSV rows
      const data = reports.map((el) => {
        const row = {
          Name: el.name || "",
          Email: el.emailId || "",
          Test: el.testName || "",
          "Test Attempt Date": el.testAttemptDate
            ? convertDate(el.testAttemptDate)
            : "",
        };

        // Fill columns dynamically
        columns.forEach((col) => {
          if (["Name", "Email", "Test", "Test Attempt Date"].includes(col))
            return;

          if (el.dynamicEvaluationResult) {
            try {
              const parsed = JSON.parse(el.dynamicEvaluationResult);
              const align = parsed?.AlignmentResults?.find(
                (a) => a.DisplayName === col,
              );
              const norm = parsed?.NormalizedTestScores?.find(
                (n) => testIdNameMap[n.TestId] === col,
              );
              const value = align?.Score ?? norm?.Score;
              row[col] = value ?? "";
            } catch {
              row[col] = "";
            }
          } else {
            // dynamicEvaluationResult is null → use testDetails
            const detail = el.testDetails?.find(
              (td) => td.testName?.trim() === col,
            );
            row[col] = detail ? detail.score : "";
          }
        });

        return row;
      });

      // 🧩 Step 4: Export CSV
      const fileName = "assessment_report_data";
      const exportType = exportFromJSON.types.csv;
      exportFromJSON({ data, fileName, exportType });
    }

    await setLoadData(false);
    await dispatch(getReport(testId, "", 1, 12, sortVal));
  };

  // Pagination handler that dispatches getReport for the selected page
  const paginate = (pageNumber) => {
    const totalPages = Math.ceil(totalCount / rows);
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setPageCount(pageNumber);
    dispatch(getReport(testId, search, pageNumber, rows, sortVal));
  };

  const Pagination = ({
    currentPage,
    totalPages,
    currentDataLength,
    total,
    paginate,
  }) => {
    const getPageNumbers = () => {
      if (totalPages <= 4) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
      } else if (currentPage <= 3) {
        return [1, 2, 3, "...", totalPages];
      } else if (currentPage >= totalPages - 2) {
        return [1, "...", totalPages - 2, totalPages - 1, totalPages];
      } else {
        return [
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages,
        ];
      }
    };
    return (
      <div className="pagination">
        <div className="pagination-info">
          {currentDataLength > 0 ? (
            <span>
              Showing <strong>{(currentPage - 1) * rows + 1}</strong>-
              <strong>{(currentPage - 1) * rows + currentDataLength}</strong> of{" "}
              <strong>{total}</strong>
            </span>
          ) : (
            <span>Showing 0-0 of 0</span>
          )}
        </div>
        <div className="pagination-buttons">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <img src="/images/leftarrow-icon.svg" alt="" />
          </button>
          {getPageNumbers().map((pageNum, index) => (
            <button
              key={index}
              onClick={() => (pageNum === "..." ? null : paginate(pageNum))}
              className={currentPage === pageNum ? "active" : ""}
              disabled={pageNum === "..."}
            >
              {pageNum}
            </button>
          ))}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            <img
              src="/images/leftarrow-icon.svg"
              alt=""
              style={{ transform: "rotate(180deg)" }}
            />
          </button>
        </div>
      </div>
    );
  };

  let testIdNameMap = {};
  if (ruleSetJson && typeof ruleSetJson === "string") {
    try {
      const parsedRuleSet = JSON.parse(ruleSetJson);
      parsedRuleSet?.tests?.forEach((t) => {
        testIdNameMap[t.testid] = t.name;
      });
    } catch (err) {
      console.error("Invalid ruleSetJson:", err);
    }
  }

  const dynamicFields = React.useMemo(() => {
    const fieldsSet = new Set();

    testReport?.forEach((el) => {
      if (el.dynamicEvaluationResult) {
        try {
          const parsed = JSON.parse(el.dynamicEvaluationResult);

          // AlignmentResults → DisplayName
          parsed?.AlignmentResults?.forEach((r) => {
            if (r.DisplayName) fieldsSet.add(r.DisplayName);
          });

          // NormalizedTestScores → test names from ruleSetJson
          parsed?.NormalizedTestScores?.forEach((r) => {
            const mappedName = testIdNameMap[r.TestId];
            if (mappedName) fieldsSet.add(mappedName);
          });
        } catch (err) {
          console.error("Error parsing dynamicEvaluationResult:", err);
        }
      }
    });

    return Array.from(fieldsSet);
  }, [testReport, ruleSetJson]);

  return (
    <div className="gappeo-my-tests">
      <Dialog
        className="screen-loader"
        open={loadData}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        Loading...
      </Dialog>
      <div style={{ padding: "24px 12px" }}>
        <h1
          className="d-flex justify-content-between flex-wrap"
          style={{
            paddingLeft: window.innerWidth > 767 ? "" : 15,
            width: window.innerWidth > 767 ? "100%" : "",
            fontFamily: `"Manrope", sans-serif`,
          }}
        >
          <img
            src="/images/back.svg"
            alt=""
            className="cursor-pointer"
            onClick={() => navigate(-1)}
          />
          Assessment Report
          <div
            style={{
              fontSize: 16,
              color: "#111928",
              cursor: "pointer",
              fontFamily: `"Manrope", sans-serif`,
            }}
            onClick={() => downloadData()}
          >
            <img src="/images/download.svg" alt="" width={20} />
            &nbsp;&nbsp; Download
          </div>
        </h1>
      </div>
      <div className="table-admin mt-3">
        <div className="search-test mt-3 d-flex align-items-center">
          <div className="has-search" style={{ width: "70%" }}>
            <span className="form-control-feedback">
              <img src="/images/search.svg" alt="" width={12} />
            </span>
            <input
              type="text"
              className="form-control"
              value={search}
              placeholder="Search candidate by Name or Email Address"
              onChange={(e) => searchName(e.target.value)}
            />
          </div>
          <div style={{ width: "30%" }} className="ms-2">
            <select
              className="form-control"
              value={sortVal}
              onChange={(e) => selectSort(e.target.value)}
            >
              <option value={2}>Assessment Attempt Date</option>
              <option value={1}>Score</option>
            </select>
          </div>
        </div>
        {isReportLoading ? (
          "Loading.."
        ) : testReport?.length > 0 ? (
          <>
            <Table responsive className="assessment-table">
              <thead>
                <tr>
                  <th>Name</th>
                  {dynamicFields.length > 0 ? (
                    dynamicFields.map((field, i) => <th key={i}>{field}</th>)
                  ) : (
                    <>
                      <th>Email</th>
                      <th>Assessment</th>
                      <th>Assessment Attempt Date</th>
                      <th>{ruleSetJson === null ? "Score" : "Status"}</th>
                    </>
                  )}
                  <th>View</th>
                </tr>
              </thead>

              <tbody className="table-body">
                {testReport.map((el) => {
                  let parsed = null;
                  try {
                    parsed = el.dynamicEvaluationResult
                      ? JSON.parse(el.dynamicEvaluationResult)
                      : null;
                  } catch (err) {
                    parsed = null;
                  }

                  const alignmentScores = parsed?.AlignmentResults || [];
                  const normalizedScores = parsed?.NormalizedTestScores || [];

                  return (
                    <tr key={el.inviteId}>
                      <td>
                        <strong>{el.name}</strong>
                      </td>

                      {dynamicFields.length > 0 ? (
                        dynamicFields.map((field, i) => {
                          // Try to find match in AlignmentResults
                          const align = alignmentScores.find(
                            (a) => a.DisplayName === field,
                          );
                          // Try to find match in NormalizedTestScores
                          const norm = normalizedScores.find(
                            (n) => testIdNameMap[n.TestId] === field,
                          );
                          const score = align?.Score ?? norm?.Score;
                          return (
                            <td key={i}>{score ? score.toFixed(2) : "NA"}</td>
                          );
                        })
                      ) : (
                        <>
                          <td>{el.emailId}</td>
                          <td>{el.testName}</td>
                          <td>
                            {el.testAttemptDate
                              ? convertDate(el.testAttemptDate)
                              : ""}
                            <br />
                            {el.testAttemptDate
                              ? formatAMPM(
                                  moment
                                    .utc(el.testAttemptDate)
                                    .local()
                                    .format(),
                                )
                              : ""}
                          </td>
                          <td>{el.status === 3 ? el.score : "NA"}</td>
                        </>
                      )}

                      <td>
                        {el.status === 3 ||
                        el.status === 4 ||
                        el.status === 5 ? (
                          <img
                            src="/images/view-icon.svg"
                            alt=""
                            className="cursor-pointer"
                            onClick={() => openOneReport(el.inviteId, "new")}
                          />
                        ) : (
                          "NA"
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <Pagination
              currentPage={pageCount}
              totalPages={Math.ceil(totalCount / rows)}
              currentDataLength={testReport.length}
              total={totalCount}
              paginate={paginate}
            />
          </>
        ) : (
          <div className="empty-list">
            <img src="/images/magnifier.svg" alt="" />
            <div className="mt-2">
              <h3>There is no Test report yet</h3>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
